import React from 'react';

import Container from '@src/components/Container';
import PrimeBookCard from '@src/components/PrimeBookCard';
import RefreshControl from '@src/components/RefreshControl';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import useImmigrationBooks from '@src/hooks/useImmigrationBooks';
import useIsAdmin from '@src/hooks/useIsAdmin';

import AddToCollectionModal from './AddToCollectionModal';
import { List } from './styled';
import { Props } from './types';
import useAddImmigrationToCollection from './useAddImmigrationToCollection';

const Screen: React.FC<Props> = ({
  navigation,
  route: {
    params: { url, params, title },
  },
}) => {
  const books = useImmigrationBooks(url, params);
  const { isAdmin } = useIsAdmin();
  const handleScroll = useAnimatedHeader();
  console.log('books ionBooks', books);
  const { request: addToCollection } = useAddImmigrationToCollection();

  const [modalVisible, setModalVisible] = React.useState(false);
  const [activeImmigrationId, setActiveImmigrationId] = React.useState<
    string
  >();
  const [collectionId, setCollectionId] = React.useState<string>();

  React.useLayoutEffect(() => {
    navigation.setOptions({
      title,
      headerTitle: title,
    });
  }, [navigation, title]);

  const handleModalDismiss = () => {
    setModalVisible(false);
  };

  const handleImmigrationLongPress = React.useCallback(
    (ImmigrationId: string) => {
      if (isAdmin) {
        setActiveImmigrationId(ImmigrationId);
        setModalVisible(true);
      }
    },
    [isAdmin]
  );

  const handleAddToCollection = async () => {
    if (collectionId && activeImmigrationId && isAdmin) {
      try {
        await addToCollection(collectionId, activeImmigrationId);
        setModalVisible(false);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          onScroll={handleScroll}
          data={books.data}
          refreshControl={
            <RefreshControl
              refreshing={books.refreshing}
              onRefresh={books.handleRefresh}
            />
          }
          onEndReached={books.handleEndReached}
          renderItem={({ item }) => (
            <PrimeBookCard
              isImmigration={true}
              item={item}
              onLongPress={() => handleImmigrationLongPress(item.id)}
            />
          )}
        />
      </Container>
      <AddToCollectionModal
        visible={modalVisible}
        onDismiss={handleModalDismiss}
        onCollectionSelect={setCollectionId}
        onSubmit={handleAddToCollection}
        activeCollectionId={collectionId}
      />
    </>
  );
};

Screen.displayName = 'ImmigrationBooks';

export default Screen;
